import { render, staticRenderFns } from "./context-menu-btn.vue?vue&type=template&id=a8f23084"
import script from "./context-menu-btn.vue?vue&type=script&lang=js"
export * from "./context-menu-btn.vue?vue&type=script&lang=js"
import style0 from "./context-menu-btn.vue?vue&type=style&index=0&id=a8f23084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports